/* Fransk katalog for locale-invoice-list-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'listControl.dialog': 'Fermez la boîte de dialogue ouverte avant que le chat ne poursuive avec la liste des factures.',
  'live.set_document_type': 'Sélection du type de document …',
  'listControl.alreadyDone': 'Cette action a déjà été effectuée pour ce document dans cette demande.',
  'listControl.choice.attachment': 'Pièce jointe PDF',
  'listControl.choice.link': 'Lien',
  'listControl.choice.reminder': 'Rappel de paiement',
  'listControl.choice.purring': 'Relance',
  'listControl.working': 'Traitement de la liste des factures …',
  'listControl.unavailable': 'La liste des factures n\'est pas prête. Ouvrez la page et réessayez.',
  'listControl.selection': 'Sélectionnez des documents sans ambiguïté dans les résultats de recherche, 20 au maximum à la fois.',
  'listControl.changed': 'La liste ou la sélection a changé. Recherchez et sélectionnez à nouveau les documents.',
  'listControl.invalid': 'L\'action ne contient pas de détails valides.',
  'listControl.ineligible': 'Cette action ne convient pas à tous les documents sélectionnés.',
  'listControl.reason': 'Indiquez le motif de l\'avoir.',
  'listControl.reminder': 'Choisissez une facture impayée, le type de rappel et une nouvelle date d\'échéance. L\'envoi se fait sans frais.',
  'listControl.payment': 'Indiquez un montant dans la limite du solde restant dû, une date de paiement et un compte de paiement pour une facture.',
  'listControl.conversion': 'Sélectionnez un devis finalisé sans conversion antérieure. Utilisez Créer sur la page si vous avez besoin d\'une conversion supplémentaire.',
  'listControl.uncertain': 'Le résultat n\'est pas confirmé. Vérifiez le document avant une nouvelle tentative ; le chat ne réessaie pas automatiquement.',
  'listControl.unsaved': 'Enregistrez ou fermez le brouillon ouvert avant de changer de document.',
  'listControl.stopped': 'Le reste de la sélection n\'a pas été traité.',
  'listControl.done.searched': 'La recherche est affichée dans la liste des factures.',
  'listControl.done.selected': 'Les documents sont sélectionnés dans la liste.',
  'listControl.done.opened': 'Le document est ouvert.',
  'listControl.done.unsaved': 'Le brouillon est ouvert et n\'est pas encore enregistré.',
  'listControl.done.prepared': 'L\'action et les détails sont affichés ci-dessous.',
  'listControl.done.sent': 'Envoyé.',
  'listControl.done.paid': 'Le paiement est enregistré.',
  'listControl.done.deleted': 'Le brouillon est supprimé.',
  'listControl.done.archived': 'Archivé.',
  'listControl.done.restored': 'Restauré depuis l\'archive.',
  'listControl.done.creditDraft': 'L\'avoir est enregistré comme brouillon.',
  'listControl.done.issued': 'Le document est créé.',
  'listControl.operation.send': 'Envoyer les documents',
  'listControl.operation.reminder': 'Envoyer un rappel / une relance sans frais',
  'listControl.operation.credit': 'Créer un avoir',
  'listControl.operation.archive': 'Archiver',
  'listControl.operation.restore': 'Restaurer depuis l\'archive',
  'listControl.operation.delete_draft': 'Supprimer le brouillon',
  'listControl.operation.register_payment': 'Enregistrer un paiement',
  'listControl.operation.issue_draft': 'Créer le document',
  'listControl.option.recipientEmail': 'Destinataire',
  'listControl.option.deliveryMode': 'Mode d\'envoi',
  'listControl.option.variant': 'Type',
  'listControl.option.dueDate': 'Date d\'échéance',
  'listControl.option.comment': 'Commentaire',
  'listControl.option.creditReason': 'Motif',
  'listControl.option.issue': 'Créer un avoir finalisé',
  'listControl.option.amount': 'Montant',
  'listControl.option.date': 'Date de paiement',
  'listControl.option.settlementAccountCode': 'Compte de paiement',
  'listControl.option.note': 'Note',
  'live.done.set_document_type': 'Le type de document est sélectionné.',
});
